import React from 'react';
import { connect, useSelector } from 'react-redux';
import { getVariantsModel, isProductSet } from 'features/product-info/ducks/selectors';
import type { CommonlyExcludedHTMLAttributeNames, HTMLAttributes } from 'types/utils';
import { Dispatch } from 'redux';
import { VARIANT_ITEM_CLICK } from 'common/components/product-variants/ducks/actions';
import { Variant } from './components/multi-axis-dropdown/components/variants-drawer-content/variant-axis/utils/types';
import { ColorCarousel, MultiAxisDropdown, SingleAxisDropdown } from './components';
import { AxisPoint } from './types';
import { calculateHideAxis } from './utils';

type PdpVariantsProps = { onVariantClick: (ap: AxisPoint) => void } & Omit<
  HTMLAttributes,
  CommonlyExcludedHTMLAttributeNames
>;

export const Variants: React.FC<PdpVariantsProps> = ({ onVariantClick }) => {
  const variantsModelContainer = useSelector(getVariantsModel);
  const isSet = useSelector(isProductSet);
  const { variantsModel, activePoint } = variantsModelContainer ?? {};
  const isHideAxis = calculateHideAxis(variantsModel);

  if (!isHideAxis) {
    if (variantsModel && variantsModel.length === 1) {
      return variantsModel[0].asImageThumb ? (
        <ColorCarousel
          variantsModel={variantsModel}
          activePoint={activePoint}
          onVariantClick={onVariantClick}
        />
      ) : (
        <SingleAxisDropdown
          isProductSet={isSet}
          variantsModel={variantsModel}
          activePoint={activePoint}
          onVariantClick={onVariantClick}
        />
      );
    }
    if (variantsModel && variantsModel.length > 1) {
      return (
        <MultiAxisDropdown isProductSet={isSet} variantsModel={variantsModel} activePoint={activePoint} />
      );
    }
  }

  return null;
};
export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onVariantClick: (payload: Variant) => dispatch(VARIANT_ITEM_CLICK(payload)),
});

export const PdpVariants = connect(null, mapDispatchToProps)(Variants);
